module.exports = __webpack_public_path__ + "img/tag-promotion.dee22904.svg";